export default __webpack_public_path__ + "static/media/tiramisu.f7c37d80.jpg";